import { RodentIcon } from './RodentIcon';

/**
 * author: Google
 * id AA8B7EA9-2DB2-4591-94E0-A457373E64C1
 * name rodent
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/rodent.svg
 * tags
 * - Animal 
 */
export const RatIcon = RodentIcon;
export default RatIcon